module.exports = {"430582001":"大禾塘街道","430582002":"两市塘街道","430582003":"宋家塘街道","430582101":"牛马司镇","430582102":"界岭镇","430582103":"九龙岭镇","430582104":"仙槎桥镇","430582105":"火厂坪镇","430582106":"佘田桥镇","430582107":"灵官殿镇","430582108":"团山镇","430582109":"砂石镇","430582110":"廉桥镇","430582111":"流光岭镇","430582112":"流泽镇","430582113":"魏家桥镇","430582114":"野鸡坪镇","430582115":"杨桥镇","430582116":"水东江镇","430582117":"黑田铺镇","430582118":"简家陇镇","430582201":"双凤乡","430582202":"周官桥乡","430582203":"堡面前乡","430582204":"斫曹乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430582.json
// module id = 1984
// module chunks = 0